/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS202: Simplify dynamic range loops
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import FocusTrap from 'utils/modal-focus-trap';
import { EventEmitter } from '../../coffee/event_emitter';

// Interface for event button state change, on event/show
//
// This is the version for Emphasis.

// When set, forces this to be considered the active element rather than document.activeElement
// in eventAttendanceChanged.
//
// This is to support the lightbox interstitial for "change dates", in order to properly restore
// focus to the opening button afterwards.
//
// There's an interaction between the lightbox code (which tries to restore focus as of when it was opened),
// and the eventAttendanceChanged callback, where the callback happens first, then the lightbox restores focus
// to a now-missing element. Manually tracking and overriding this way allows the focus to be properly restored
// to the button after the lightbox is closed.
//
// This needs to be outside any namespaces, as both modules need to share the value.
let change_dates_opener = null;

namespace('Slzr.Theme', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  const events = new EventEmitter;
  exports.Events = events;

  // Called by the server in response to event attendance changes
  //
  // options hash:
  //   event_id: ID of event changed
  //   event_instance_id: ID of event instance changed, if known. (detail page "unconfirm" has no ID)
  //   attending: new attendance state
  //   button_html: new html for this button
  //   lightbox_content: html to display in a lightbox (for ticket required, *not* date selector)
  //
  // additionaly, for detail page:
  //   attendees: new content for attendees block
  //   status: new content for event status area
  //   hide_lightbox: should a visible lightbox be closed
  return exports.eventAttendanceChanged = function(options) {
    $(document).trigger('slzr:attendance:change', options);
    events.emit('attendanceChange', options);

    if (options.hide_lightbox) { hideIbox(); }

    let selector = '[data-event-interest]';
    selector += `[data-event-id=\"${options.event_id}\"]`;
    if (options.event_instance_id) { selector += `[data-event-instance-id=\"${options.event_instance_id}\"]`; }

    // Determine if the active button is one of the items matching the selector, and store its index if so
    const buttons = document.querySelectorAll(selector);

    // This is basically buttons.indexOf(document.activeElement), but NodeList doesn't implement indexOf
    const active_button = change_dates_opener || document.activeElement;
    let active_button_index = -1;
    for (let index = 0, end = buttons.length, asc = 0 <= end; asc ? index <= end : index >= end; asc ? index++ : index--) {
      if (buttons[index] === active_button) { active_button_index = index; }
    }

    // force hover state to respective .em-card
    const parent_card = active_button.closest(".em-card");
    $(parent_card).addClass("em-card--hovered");


    // Replace the relevant interest buttons with their updated state
    $(selector).replaceWith(options.button_html);

    // Restore focus to the associated, now replaced button
    if (active_button_index > -1) {
      __guard__(document.querySelectorAll(selector).item(active_button_index), x => x.focus());
      // If we're manually tracking an opener element, also store the new element there so focus can be restored again later
      if (change_dates_opener != null) { change_dates_opener = document.querySelectorAll(selector).item(active_button_index); }
    }

    // remove forced hover state from .em-card
    $(parent_card).removeClass("em-card--hovered");

    if (options.lightbox_content) { Slzr.Lightbox.open({
      padding: 0,
      content: options.lightbox_content,
      onClosed() {
        // Remove the focus trap.
        // The switch to the new modal content doesn't trigger a re-trap, and it loses the trapped state.
        FocusTrap.untrap();
        // Restore focus to the stored opener element
        if (change_dates_opener != null) {
          change_dates_opener.focus();
        }
        return change_dates_opener = null;
      }
    }); }

    if (options.attendees) {
      const attendee_selector = `[data-event-attendees=\"${options.event_id}\"]`;
      return $(attendee_selector).html(options.attendees);
    }
  };
});


// Event handlers for the event interest button
//
// data-action is:
//   event-going -> I'm Interested
//   event-not-going -> Not Interested
//   event-change-attendance -> Display attendance popup
//
// Gets event id from data-event-id and/or data-event-instance-id on the button.
// If an invitation is present, data-invitation is used.

namespace('Slzr.UI.EventInterestButton', function(exports, top) {
  let submitInterest;
  const $ = Slzr.jQuery;

  //# URLS ##

  // URL for the multi-date going lightbox
  const EVENT_GOING_URL = "/event/@@EVENT_ID@@/going";

  // URL for confirming attendance
  const EVENT_CONFIRM_URL = "/event/@@EVENT_ID@@/confirm";
  const EVENT_UNCONFIRM_URL = "/event/@@EVENT_ID@@/unconfirm";
  const EVENT_INVITE_URL = "/event/@@EVENT_ID@@/invite_friends";

  // Retrieve the event data from the button
  const getEventData = element => ({
    event_id: $(element).data('event-id'),
    event_instance_id: $(element).data('event-instance-id'),
    attendance_date: $(element).data('event-attendance-date'),
    invitation_id: $(element).data('event-invitation'),
    invitation_token: $(element).data('event-invitation-token'),
    not_logged_in: !!$(element).data('post-login-action')
  });

  // Build the appropriate URL from the specified template
  //
  // data should be same format as getEventData above
  //
  // Currently, just creates the path. Additional params are posted.
  const buildUrl = (template, data) => template.replace('@@EVENT_ID@@', data.event_id);

  return submitInterest = function(url_template, event_data) {
    const url = buildUrl(url_template, event_data);

    const options = {};
    options['return'] = location.href;
    if (event_data.event_instance_id) {
      options['instance_id'] = event_data.event_instance_id;
    } else if (event_data.attendance_date) {
      options['date'] = event_data.attendance_date;
    }

    if (event_data.invitation_id && event_data.invitation_token) {
      options['invite'] = event_data.invitation_id;
      options['token'] = event_data.invitation_token;
    }

    // Only request attendees if there's a spot to put them on the page
    options['include_attendees'] = !!$(`[data-event-attendees=\"${event_data.event_id}\"]`).get(0);

    if (!event_data.not_logged_in) {
      return $.post(url, options)
        .done((event, xhr, settings) => $(document).trigger('slzr:attendance:change'));
    }
  };
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}